

import Vue from 'vue'
import Index from './Index'
import Router from 'vue-router'
import routes from './routes'
import VueResource from 'vue-resource'
import rem from '@/components/js/rem'
import common from '@/components/js/common'
import sinaShare from '@/components/js/share'
import Qs from 'qs'
import Calendar from 'vue2-datepick';
import axios from 'axios'
Vue.prototype.$ajax= axios;
Vue.use(Router);
Vue.use(VueResource);
Vue.use(Qs);
Vue.use(rem);
Vue.use(common);
import AlertPlugin from 'vux/src/plugins/alert/index.js'

Vue.use(AlertPlugin)
import LoadingPlugin from 'vux/src/plugins/loading/index.js'

Vue.use(LoadingPlugin)
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'

Vue.use(ConfirmPlugin)
import ToastPlugin from 'vux/src/plugins/toast/index.js'

Vue.use(ToastPlugin)
Vue.use(Calendar);
import Cell from 'vux/src/components/cell/index.vue'

import { Icon } from 'vant';
Vue.use(Icon);
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);
Vue.component('cell', Cell)




let router = new Router({
mode: 'history',
base:'/meeting',
routes
});

const app = new Vue({
router,

}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js